import { JSX } from 'react';
import { PromptForMissingFieldValue } from 'src/shared/PromptForMissingDatasource';
import { C25LocationInfoProps } from './C25LocationInfo.types';
import { CreateLocationInfoModel } from './C25LocationInfo.service';
import { LocationInfo } from '@ahc-digital/component-library';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { GetGoogleMapAPI } from 'src/shared/GoogleMap.service';
import { GetServerSideComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';
import { LayoutServiceDataExtensions } from 'src/shared/shared.types';

const Default = (props?: C25LocationInfoProps): JSX.Element => {
  const { params, googleMapsApiKey = '' } = props || {};
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (Object.keys(props?.fields?.Location?.fields || {}).length === 0)
    return <PromptForMissingFieldValue fieldName={'Location'} rendering={props?.rendering} />;

  return (
    <LocationInfo
      {...CreateLocationInfoModel(props)}
      googleMapsApiKey={googleMapsApiKey}
      className={translationClasses(params)}
      data-component={marketingRenderingName}
    />
  );
};

export default checkDatasourceForRendering<C25LocationInfoProps>(Default);

export const getServerSideProps: GetServerSideComponentProps = async (_rendering, layoutData) => {
  const context = layoutData.sitecore.context as LayoutServiceDataExtensions['context'];
  return {
    googleMapsApiKey: GetGoogleMapAPI(context?.envVariableNameForGoogleMapAPI?.value || ''),
  };
};
